export const hospitalApi = {
  deleteHos: `Hospital/hospital/delete/id?hospitalid=`,
  activateOrDeactivate: `Hospital/hospitals/hospitalplan/ActivateOrDeActivate?`,
  delinkAccountManger: `AccountManager/AccountManager/LinkOrDeLink?`,
};
